import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { stopEventRefs } from "../subjects/stopEvent/refs";

/**
 * What the stop is for, as the vendor's task type states it.
 */
export const ArrivalStopRoleSchema = z.enum(["pickup", "delivery", "stop"]).openapi("ArrivalStopRole");

export type ArrivalStopRole = z.infer<typeof ArrivalStopRoleSchema>;

/**
 * The driver arrived at a stop.
 */
export const arrivalV1 = tmsEventKind(
  { category: "movement", kind: "arrival", version: 1 },
  {
    refs: stopEventRefs,
    facts: {
      stopName: z.string(),
      /** Always null today: arrival forms carry no city, and job locations are a later ticket's. */
      city: z.string().nullable(),
      stopRole: ArrivalStopRoleSchema,
    },
  },
);

export const ArrivalV1Schema = arrivalV1.schema;
export const ArrivalV1FactsSchema = arrivalV1.facts;

export type ArrivalV1 = z.infer<typeof ArrivalV1Schema>;
export type ArrivalV1Facts = z.infer<typeof ArrivalV1FactsSchema>;

/** Every version of `arrival`, keyed by version. What `catalog.ts` places under `movement`. */
export const arrival = { 1: arrivalV1 } as const;
